import React from 'react';
import Icon from '../../../@shared/icon';
import './index.scss';

export interface ICustomArrowProps {
  direction: 'previous' | 'next';
  onClick?: () => void;
}

const CustomArrow = ({ direction, onClick }: ICustomArrowProps): JSX.Element => {
  const icon = `arrow-chevron-${direction === 'previous' ? 'left' : 'right'}`;
  return (
    <button
      className={`custom-arrow
       custom-arrow--${direction === 'previous' ? 'left' : 'right'}`}
      aria-label={`${direction}slide / item`}
      type="button"
      onClick={onClick}
    >
      <Icon iconName={icon} size={32} extraClassName="custom-arrow__icon" />
    </button>
  );
};

export default CustomArrow;
